define(['jquery'], function ($) {
   "use strict";

   /**
    * Collapses the text content of an element to match the element's width
    * @param jElement
    */
   return function (jElement) {
      // TODO in IE7+ and WebKit browsers, this can just do a css change to overflow:hidden;text-overflow:ellipsis;white-space:nowrap;
      // Don't double-collapse
      if (jElement.find('span').length > 0) {
         return;
      }

      var strOriginalText = $.trim(jElement.text());

      // Remove multiple white spaces as they trick our width detector
      strOriginalText = strOriginalText.replace(/\s+/g, " ");

      // Note: We have to split a string to iterate
      // over its individual characters in IE6 
      var aStrOriginalString = strOriginalText.split(''),

         elNewContainer = $('<span />'),
         elText = $('<span />'),
         elEllipses = $('<span>&hellip;</span>'),
         iLastWidth = elNewContainer.width(),
         strCurrentText = '',
         iCharWithEllipses = 0;

      jElement.empty();
      jElement.append(elNewContainer);
      elNewContainer.append(elText);
      elNewContainer.append(elEllipses);

      // Loop through every character in the original text
      $.each(aStrOriginalString, function (i, strChar) {
         var iCurrentWidth;

         strCurrentText += strChar;
         elText.text(strCurrentText);
         iCurrentWidth = elNewContainer.width();

         // Has the text wrapped?
         if (iCurrentWidth <= iLastWidth) {
            // With the ellipses still attached?!
            if (iCharWithEllipses === undefined) {
               // Record the character it wrapped at
               iCharWithEllipses = i;

               // Hide 'dem ellipses
               elEllipses.hide();

               // Now we will loop through the rest of the string,
               // checking if the full text can be displayed without
               // adding the ellipses

               // Did the text wrap again, even without those ellipses?
            } else {
               // Too bad. Slice and dice!
               strCurrentText = strCurrentText.slice(0, iCharWithEllipses - 1);
               elText.text(strCurrentText);
               elEllipses.show();

               // Break the loop
               return false;
            }
         }

         // Save the width so we can tell if the text wrapped
         // in the next iteration
         iLastWidth = iCurrentWidth;
      });

      // If we are showing the original text, no need for ellipses
      if (strCurrentText === strOriginalText) {
         elEllipses.hide();
      }

      // Let the user see the unblemished text if they care to hover over it
      jElement.attr('title', strOriginalText);
   };
});
